import React, { useEffect, useState } from "react";
import * as S from "./style";
import { useLocation } from "react-router-dom";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch } from "react-redux";
import { resetDynamicAgentGroupState } from "../../store/slices/smartConnect/dynamicAgentGroup";

const CustomNavigation = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isActive = (path) => location.pathname.startsWith(path);
  const [isSmartConnectOpen, setIsSmartConnectOpen] = useState(false);
  const [isViCtsOpen, setIsViCtsOpen] = useState(false);

  useEffect(() => {
    if (location.pathname.startsWith("/smart-connect")) {
      setIsSmartConnectOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.startsWith("/vi-cts")) {
      setIsViCtsOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      // reset ONLY if leaving did-assignments module
      if (!location.pathname.startsWith("/smart-connect/did-assignments")) {
        dispatch(resetDynamicAgentGroupState());
      }
    };
  }, [dispatch, location.pathname]);

  return (
    <S.NavWrapper>
      <S.SectionTitle>Dashboard</S.SectionTitle>
      {hasPermission(PERMISSIONS.DASHBOARD.VIEW) && (
        <S.NavItem>
          <S.NavLink $active={isActive("/app")} to="/app">
            Dashboard
          </S.NavLink>
        </S.NavItem>
      )}
      {hasPermission(PERMISSIONS.CAMPAIGN.VIEW) && (
        <S.NavItem>
          <S.NavLink $active={isActive("/campaigns")} to="/campaigns">
            Campaigns
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.SMART_CONNECT.VIEW) && (
        <S.NavItem>
          <S.ParentNavLink
            $active={isSmartConnectOpen}
            onClick={() => setIsSmartConnectOpen((prev) => !prev)}
          >
            Smart Connect &nbsp; <IoIosArrowDown />
          </S.ParentNavLink>

          {isSmartConnectOpen && (
            <S.SubMenu>
              <S.NavLink
                $active={isActive("/smart-connect/summary")}
                to="/smart-connect/summary"
              >
                Smart Connect Summary
              </S.NavLink>

              <S.NavLink
                $active={isActive("/smart-connect/settings")}
                to="/smart-connect/settings"
              >
                Smart Connect Settings
              </S.NavLink>

              <S.NavLink
                $active={isActive("/smart-connect/agent-list")}
                to="/smart-connect/agent-list"
              >
                Smart Connect Agent List
              </S.NavLink>

              <S.NavLink
                $active={isActive("/smart-connect/add-dids")}
                to="/smart-connect/add-dids"
              >
                Smart Connect Add DIDs
              </S.NavLink>

              <S.NavLink
                $active={isActive("/smart-connect/did-assignments")}
                to="/smart-connect/did-assignments"
              >
                Smart Connect DID Assignment List
              </S.NavLink>

              <S.NavLink
                $active={isActive("/smart-connect/deleted-dids")}
                to="/smart-connect/deleted-dids"
              >
                Smart Connect Deleted DID List
              </S.NavLink>
            </S.SubMenu>
          )}
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.USERS.VIEW) && (
        <S.NavItem>
          <S.NavLink $active={isActive("/users")} to="/users">
            Users
          </S.NavLink>
        </S.NavItem>
      )}
      {hasPermission(PERMISSIONS.TEMPLATES.VIEW) && (
        <S.NavItem>
          <S.NavLink $active={isActive("/templates")} to="/templates">
            Templates
          </S.NavLink>
        </S.NavItem>
      )}
      {hasPermission(PERMISSIONS.JOB_LIST.VIEW) && (
        <S.NavItem>
          <S.NavLink $active={isActive("/job-list")} to="/job-list">
            Job List
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.VI_CTS.VIEW) && (
        <S.NavItem>
          <S.ParentNavLink
            $active={isViCtsOpen}
            onClick={() => setIsViCtsOpen((prev) => !prev)}
          >
            VI-CTS &nbsp; <IoIosArrowDown />
          </S.ParentNavLink>

          {isViCtsOpen && (
            <S.SubMenu>
              <S.NavLink
                $active={isActive("/vi-cts/listView")}
                to="/vi-cts/listView"
              >
                VI-CTS List View
              </S.NavLink>

              <S.NavLink
                $active={isActive("/vi-cts/transferSetting")}
                to="/vi-cts/transferSetting"
              >
                VI-CTS Transfer Setting
              </S.NavLink>
            </S.SubMenu>
          )}
        </S.NavItem>
      )}
      {hasPermission(PERMISSIONS.PRE_LEADS.VIEW) && (
        <S.NavItem>
          <S.NavLink $active={isActive("/pre-leads")} to="/pre-leads">
            Bitrix Pre Leads
          </S.NavLink>
        </S.NavItem>
      )}
      {hasPermission(PERMISSIONS.LEADS_DATA_TRANSFER_SETTING.VIEW) && (
        <S.NavItem>
          <S.NavLink
            $active={isActive("/leads-data-transfer-setting")}
            to="/leads-data-transfer-setting"
          >
            Leads Data Transfer Setting
          </S.NavLink>
        </S.NavItem>
      )}
      {hasPermission(PERMISSIONS.BLOCK_CONTACTS.VIEW) && (
        <>
          <S.SectionTitle>Block Contacts</S.SectionTitle>
          <S.NavItem>
            <S.NavLink
              $active={isActive("/block-contacts/global")}
              to="/block-contacts/global"
            >
              Global Block
            </S.NavLink>
          </S.NavItem>
          <S.NavItem>
            <S.NavLink
              $active={isActive("/block-contacts/campaign")}
              to="/block-contacts/campaign"
            >
              Block By Campaigns
            </S.NavLink>
          </S.NavItem>
          <S.NavItem>
            <S.NavLink
              $active={isActive("/block-contacts/tags")}
              to="/block-contacts/tags"
            >
              Block By Campaign Tags
            </S.NavLink>
          </S.NavItem>
        </>
      )}

      {(hasPermission(PERMISSIONS.CAMPAIGN.VIEW) ||
        hasPermission(PERMISSIONS.EMAIL_CAMPAIGN_REPORT.VIEW) ||
        hasPermission(PERMISSIONS.IVR_CAMPAIGN_REPORT.VIEW) ||
        hasPermission(PERMISSIONS.EMAIL_SUPPRESSION_LIST.VIEW) ||
        hasPermission(PERMISSIONS.EMAIL_SUPPRESSION_LIST.VIEW)) && (
        <S.SectionTitle>Reports</S.SectionTitle>
      )}

      {hasPermission(PERMISSIONS.CAMPAIGN.VIEW) && (
        <S.NavItem>
          <S.NavLink
            $active={isActive("/campaign/report")}
            to="/campaign/report"
          >
            Campaign Report
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.EMAIL_CAMPAIGN_REPORT.VIEW) && (
        <S.NavItem>
          <S.NavLink
            $active={isActive("/campaign/email-campaing-report")}
            to="/campaign/email-campaing-report"
          >
            Email Campaign Run Report
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.IVR_CAMPAIGN_REPORT.VIEW) && (
        <S.NavItem>
          <S.NavLink
            $active={isActive("/campaign/ivr-campaign-report")}
            to="/campaign/ivr-campaign-report"
          >
            IVR Campaign Run Report
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.SMS_CAMPAIGN_REPORT.VIEW) && (
        <S.NavItem>
          <S.NavLink
            $active={isActive("/campaign/sms-campaign-report")}
            to="/campaign/sms-campaign-report"
          >
            SMS Campaign Run Report
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.EMAIL_SUPPRESSION_LIST.VIEW) && (
        <S.NavItem>
          <S.NavLink
            $active={isActive("/campaign/email-suppression-list")}
            to="/campaign/email-suppression-list"
          >
            Email Suppression List
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.ROLES_MANAGEMENT.VIEW) && (
        <S.SectionTitle>Roles & Permissions</S.SectionTitle>
      )}
      {hasPermission(PERMISSIONS.ROLES_MANAGEMENT.VIEW) && (
        <S.NavItem>
          <S.NavLink
            $active={isActive("/roles-management")}
            to="/roles-management"
          >
            Roles Management
          </S.NavLink>
        </S.NavItem>
      )}

      {hasPermission(PERMISSIONS.IP_MANAGEMENT.VIEW) && (
        <>
          <S.SectionTitle>IP Management</S.SectionTitle>
          <S.NavItem>
            <S.NavLink $active={isActive("/ip-management")} to="/ip-management">
              IP Management
            </S.NavLink>
          </S.NavItem>
        </>
      )}
    </S.NavWrapper>
  );
};

export default CustomNavigation;
